export class Setor {
  id: number;
  descricao: string;  
}
